import React from 'react';
import ReactDatePicker from 'react-datepicker';
import moment from 'moment';

//https://reactdatepicker.com/
import 'react-datepicker/dist/react-datepicker.css';

import "./date-range-picker-wrapper.css";

class DatePicker extends React.Component {
  constructor (props) {
    super(props);

    var dti;

    if(props.dti){
      const dtiArr = props.data.split('/');
      const dtiFormated = dtiArr[2]+'-'+dtiArr[1]+'-'+dtiArr[0];
      dti = dtiFormated;
    }

    if(props.value){
      const dtiArr = props.value.split('/');
      const dtiFormated = dtiArr[2]+'-'+dtiArr[1]+'-'+dtiArr[0];
      dti = dtiFormated;
    }

    this.state = {
      date: dti ? moment(dti) : moment()
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(date) {
    this.setState({
      date: date
    });
    this.props.handleChange(date);
  }

  render() {
    return (
      <div className="box-input box-input--date">
          <div className="box-input--title">{this.props.title}</div>
          <div className="box-input--border">
            <div className="box-input--inner">
              <ReactDatePicker
                name={this.props.name}
                selected={this.state.date}
                onChange={this.handleChange}
              />
            </div>
          </div>
      </div>
    );
  }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/form/DatePicker.js